import KlaviyoFormAtom from '@klv/atoms/klaviyo-form';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/klaviyoForm.module.scss';

import type { IKlaviyoFormOrganism } from './types';

const KlaviyoFormOrganism = ({
  backgroundColor,
  bodyCopy,
  className,
  formId,
  headline,
  ...rest
}: IKlaviyoFormOrganism) => (
  <div className={generateClassName(['klaviyoForm', className, styles.klaviyoForm, styles[backgroundColor]])} {...rest}>
    <div className='grid'>
      {(headline || bodyCopy) && (
        <div className={generateClassName([styles.richText, styles.gridAlignment])}>
          {headline && (
            <div className="h3">{headline}</div>
          )}
          {bodyCopy && (
            <div className="p1">{bodyCopy}</div>
          )}
        </div>
      )}
      <KlaviyoFormAtom className={styles.gridAlignment} formId={formId} />
    </div>
  </div>
);

export default KlaviyoFormOrganism;
